import React, { useState } from 'react';
import { InputNumber } from 'antd';
import { SeparateNumberFormat } from '../../../../../../services/utils';
import { impressions as impressionsMath } from '../../../services/investmentCalculations';

/**
 * @param {number}   promisedShows
 * @param {number}   multiplier
 * @param {function} onChangePromisedShows - (promisedShows: number) => void
 */
const ImpressionsInput = ({
  promisedShows,
  multiplier,
  onChangePromisedShows,
  onBlur,
  ...rest
}) => {
  const projectedImpressions = impressionsMath.fromSpots(promisedShows, multiplier);

  const [typedImpressions, setTypedImpressions] = useState(null);

  // The step for the InputNumber is the multiplier.
  const stepImpressions = Math.max(1, Math.round(multiplier > 0 ? multiplier : 1));

  const handleChange = inputValue => {
    if (inputValue === '' || inputValue === null || inputValue === undefined) {
      setTypedImpressions('');
      return;
    }
    const parsedValue = Number(inputValue);
    if (!isFinite(parsedValue)) return;
    const nextImpressions = Math.max(0, Math.trunc(parsedValue));
    setTypedImpressions(nextImpressions);
    onChangePromisedShows(impressionsMath.toSpots(nextImpressions, multiplier));
  };

  const handleBlur = event => {
    setTypedImpressions(null);
    if (onBlur) onBlur(event);
  };

  return (
    <InputNumber
      {...rest}
      type="text"
      formatter={SeparateNumberFormat}
      parser={inputValue => {
        const cleaned = String(inputValue).replace(/\D/g, '');
        return cleaned === '' ? '' : Number(cleaned);
      }}
      min={0}
      step={stepImpressions}
      precision={0}
      value={typedImpressions === null ? projectedImpressions : typedImpressions}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  );
};

export default ImpressionsInput;
